import { useState } from "react";
import { EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const RemoveStoryButton = ({ story, onRemoved }) => {
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    setBusy(true);
    try {
      await api.post(`/stories/${story.id}/hide`);
      toast.success("Story removed from the page.");
      onRemoved(story.id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't remove the story.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="absolute top-4 right-4 inline-flex items-center gap-1.5 font-mono text-[10px] tracking-widest uppercase text-muted-foreground hover:text-destructive border border-border hover:border-destructive/60 rounded-full px-3 py-1.5 transition-colors"
          data-testid={`story-remove-btn-${story.id}`}
        >
          <EyeOff className="h-3 w-3" /> Remove
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="story-remove-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Remove this story?</AlertDialogTitle>
          <AlertDialogDescription>
            “{story.title}” will be hidden from the Shift Stories page. It isn't erased, so it can be brought back later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="story-remove-cancel">Keep it</AlertDialogCancel>
          <AlertDialogAction onClick={remove} disabled={busy} data-testid="story-remove-confirm">
            Remove story
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
